import React from 'react';
import { Order } from 'src/components/Table/types';

export enum Columns {
  FullName = 'fullName',
  Status = 'status',
}

export type HeadCell = {
  id: Columns;
  label: string;
  order: Order;
};

export type Row = {
  cells: {
    [Columns.FullName]: React.ReactElement;
    [Columns.Status]: React.ReactElement;
  };
  link: string;
};
